import { clearPosCatalogCache } from "./posCatalogCache";

export const lsSave = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const lsGet = (key) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
};

export const lsUpdate = (key, newValue) => {
  localStorage.setItem(key, JSON.stringify(newValue));
};

export const lsDelete = (key) => {
  localStorage.removeItem(key);
};

// Everything in localStorage that belongs to ONE signed-in session at ONE terminal.
//
// These used to outlive both logout and login — only `bizContext` was ever cleared —
// so the next cashier at the same till inherited the previous one's open register
// (with its outlet, tax and receipt settings) and any half-finished sale ids. One
// helper because three different code paths do this and they had already drifted:
// hooks/useLogout.js, components/body/profile/UserAction.jsx and components/auth/Login.jsx.
//
// `bizContext` is deliberately included so callers need only this one call.
export const clearSessionScopedCache = () => {
  // The POS catalogue held in memory belongs to this session too.
  clearPosCatalogCache();
  [
    "bizContext",
    "activeReg", // the till session — see context/RegisterContext.jsx
    "quoteSaleId",
    "procSaleId",
    "editSaleId",
  ].forEach((key) => localStorage.removeItem(key));
};
